import * as React from "react";
const SvgNoVolumeCalculations = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 253.277 162.413",
	...props
}, /* @__PURE__ */ React.createElement("g", { transform: "translate(-227 -187)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M471.127,187H234.53a8.35,8.35,0,0,0-8.34,8.34V220.8a8.35,8.35,0,0,0,8.34,8.34h236.6a8.35,8.35,0,0,0,8.34-8.34V195.34a8.35,8.35,0,0,0-8.34-8.34Zm7.462,33.8a7.473,7.473,0,0,1-7.462,7.462H234.53a7.473,7.473,0,0,1-7.462-7.462V195.34a7.473,7.473,0,0,1,7.462-7.462h236.6a7.473,7.473,0,0,1,7.462,7.462Z",
	transform: "translate(0.81)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M471.127,349.414H234.53a8.35,8.35,0,0,1-8.34-8.34v-25.46a8.35,8.35,0,0,1,8.34-8.34h236.6a8.35,8.35,0,0,1,8.34,8.34v25.46a8.35,8.35,0,0,1-8.34,8.34Zm-236.6-41.262a7.471,7.471,0,0,0-7.462,7.462v25.46a7.471,7.471,0,0,0,7.462,7.463h236.6a7.47,7.47,0,0,0,7.462-7.462V315.614a7.471,7.471,0,0,0-7.462-7.462Z",
	transform: "translate(0.81 -60.137)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M471.127,469.688H234.53a8.35,8.35,0,0,1-8.34-8.34v-25.46a8.35,8.35,0,0,1,8.34-8.34h236.6a8.35,8.35,0,0,1,8.34,8.34v25.46a8.35,8.35,0,0,1-8.34,8.34Zm-236.6-41.263a7.47,7.47,0,0,0-7.462,7.462v25.46a7.471,7.471,0,0,0,7.462,7.462h236.6a7.47,7.47,0,0,0,7.462-7.462V435.888a7.47,7.47,0,0,0-7.463-7.464Z",
	transform: "translate(0.81 -120.274)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M292.293,229.14a14.516,14.516,0,1,1,14.516-14.516A14.516,14.516,0,0,1,292.293,229.14Z",
	transform: "translate(-24.983 -6.554)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M514.738,245.82H359.788a3.512,3.512,0,0,1,0-7.023h154.95a3.512,3.512,0,0,1,0,7.023Z",
	transform: "translate(-64.233 -25.898)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M464.252,215.97H359.781a3.512,3.512,0,0,1,0-7.023H464.252a3.512,3.512,0,0,1,0,7.023Z",
	transform: "translate(-64.23 -10.973)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M292.293,349.413A14.516,14.516,0,1,1,306.809,334.9,14.516,14.516,0,0,1,292.293,349.413Z",
	transform: "translate(-24.983 -66.69)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M514.738,366.094H359.788a3.512,3.512,0,0,1,0-7.024h154.95a3.512,3.512,0,1,1,0,7.023Z",
	transform: "translate(-64.233 -86.035)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M464.252,336.245H359.781a3.512,3.512,0,0,1,0-7.023H464.252a3.512,3.512,0,0,1,0,7.023Z",
	transform: "translate(-64.23 -71.111)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M292.293,469.687a14.516,14.516,0,1,1,14.516-14.516A14.516,14.516,0,0,1,292.293,469.687Z",
	transform: "translate(-24.983 -126.827)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M514.738,486.367H359.788a3.512,3.512,0,0,1,0-7.024h154.95a3.512,3.512,0,1,1,0,7.023Z",
	transform: "translate(-64.233 -146.172)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M464.252,456.518H359.781a3.512,3.512,0,0,1,0-7.024H464.252a3.512,3.512,0,0,1,0,7.023Z",
	transform: "translate(-64.23 -131.247)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M299.892,227.176a1.661,1.661,0,0,1-1-.332l-.018-.014-3.762-2.878a1.672,1.672,0,0,1,2.035-2.654l2.437,1.869,5.759-7.513a1.671,1.671,0,0,1,2.343-.309h0l-.035.05.036-.05a1.674,1.674,0,0,1,.309,2.344l-6.774,8.833a1.672,1.672,0,0,1-1.33.65Z",
	transform: "translate(-33.323 -14)",
	fill: "#fff"
})));
export default SvgNoVolumeCalculations;
